import React from 'react';
import styles from './SelectionList.module.css';
import { ISelectionItem } from '../../../Types/Analyse/ISelectionItem';
import Checkbox from '../Checkbox/Checkbox';

export type SelectionListProps = {
    title: string;
    data: ISelectionItem<string>[];
    onChange: (items: ISelectionItem<string>[]) => void;
    color?: string;
    selectAllDisabled?: boolean;
    maxHeight?: string;
    /**
     * When set, Select All does not apply immediately.
     * Call `apply()` after the user confirms (e.g. via ConfirmAction).
     */
    requestSelectAll?: (selecting: boolean, apply: () => void) => void;
};

const SelectionList = ({ 
    title, 
    data, 
    onChange, 
    color, 
    selectAllDisabled = false,
    maxHeight = "300px",
    requestSelectAll,
}: SelectionListProps) => {

    const optionClicked = (item: ISelectionItem<string>, selected: boolean) => {
        const newData = data.map(i =>
            i.id === item.id ? { ...i, selected } : i
        );
        onChange(newData);
    };

    const selectAllClicked = (selected: boolean) => {
        const apply = () => {
            const newSelectedItems = data.map(item => ({
                ...item,
                selected,
            }));
            onChange(newSelectedItems);
        };

        if (requestSelectAll) {
            requestSelectAll(selected, apply);
            return;
        }

        apply();
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h3 className={styles.title}>{title}</h3>
                {!selectAllDisabled && (
                    <div className={styles.selectAllContainer}>
                        <span className={styles.selectAllText}>Select All</span>
                        <Checkbox
                            color={color}
                            clickHandler={selectAllClicked}
                            value={data.every((item) => item.selected) && data.length > 0}
                        />
                    </div>
                )}
            </div>
            
            <div className={styles.listContainer} style={{ maxHeight }}>
                {data.map((item) => (
                    <div 
                        key={item.id} 
                        className={`${styles.listItem} ${item.disabled ? styles.disabled : ''}`}
                        style={item.disabled ? { opacity: 0.3 } : {}}
                    >
                        <span className={styles.itemText}>{item.text}</span>
                        <Checkbox
                            color={color}
                            disabled={item.disabled}
                            clickHandler={(selected) => optionClicked(item, selected)}
                            value={item.selected}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SelectionList;
